import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { Button, Loader, Modal, Icon, Dropdown } from "semantic-ui-react";
import { deleteEventDoc } from "../store/actions/athleteActions";
import PlanPrices from "../components/modal/PlanPrices";
import ServiceAgreement from "../components/modal/ServiceAgreement";
import "./NewSignup.css";
import NewRequestsCard from "../components/layout/NewRequestsCard";

const NewSignups = (props) => {
  const [planModal, setPlanModal] = useState(false);
  const [serviceAgreement, setServiceAgreement] = useState(false);
  const handlePlanModal = (value) => {
    setPlanModal(value);
  };
  if (!props.auth.isLoaded) {
    return (
      <div className="SpinnerBackground">
        <div className="SpinnerContainer">
          <Loader size="large" active inline="centered" />
        </div>
      </div>
    );
  } else if (
    props.auth.isLoaded &&
    (props.auth.email === "csanicknaudin@gmail.com" || props.superAdmin)
  ) {
    if (props.auth.isLoaded) {
      return (
        <>
          <div className="AthleteDetailsBackground cu-profile new-signup-container">
            <div className="AthleteDetailsBannerBar"></div>
            <div className="AthleteSearchBanner main-filter-event">
              <h1>Signup Management</h1>
            </div>
            <div className="AddAthleteButtonContainer">
              <Button
                icon="dollar sign"
                labelPosition="left"
                color="olive"
                name="editedButton"
                onClick={handlePlanModal}
                content="Plans & Prices"
              />
              <Button
                color="violet"
                icon="newspaper"
                labelPosition="left"
                name="editedButton"
                onClick={() => setServiceAgreement(true)}
                content="Service Agreement"
              />
            </div>
          </div>
          <div className="custom-bg">
            <div className="AthleteEventsInfoContainer common-event">
              <div
                className={`AthleteEventsGroupContainer ${
                  props.newRequests &&
                  props.newRequests.length > 0 &&
                  (props.newRequests.length === 1
                    ? "onlyone"
                    : props.newRequests.length === 2
                    ? "onlytwo"
                    : "")
                }`}
              >
                {props.newRequests &&
                  props.newRequests.length > 0 &&
                  props.newRequests.map((data) => (
                    <NewRequestsCard data={data} key={data.id} />
                  ))}
              </div>
              {props.newRequests && props.newRequests.length < 1 && (
                <p className="not-found cu-center">There's No Data Right Now</p>
              )}
            </div>
          </div>
          <PlanPrices setOpen={handlePlanModal} open={planModal} />
          <ServiceAgreement
            setOpen={() => setServiceAgreement(false)}
            open={serviceAgreement}
          />
        </>
      );
    } else
      return (
        <div className="SpinnerBackground">
          <div className="SpinnerContainer">
            <Loader size="large" active inline="centered" />
          </div>
        </div>
      );
  } else if (props.auth.isLoaded && !props.auth.email) {
    return <Redirect to={`/login`} />;
  } else if (
    props.auth.isLoaded &&
    props.auth.email &&
    (props.auth.email !== "csanicknaudin@gmail.com" || props.superAdmin)
  ) {
    return <Redirect to={`/events`} />;
  }
  return null;
};

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    superAdmin: state.auth.superAdmin,
    newRequests: state.firestore.ordered.testNewRequests,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect((props) => {
    const firestoreArray = [
      {
        collection: "testNewRequests",
      },
    ];
    return firestoreArray;
  })
)(NewSignups);
